import { useMemo } from "react";

import { isValidObject, useAlertsStorage } from "storage/alerts";

const timeDifferenceThreshold = 10000;

const useDailyAlert = (alertName: string, id: string): boolean => {
  const { getAlert, setAlert } = useAlertsStorage();

  const actualDate = useMemo((): Date => new Date(), []);
  const alert = getAlert();

  // Check if the data structure is valid and the specific alert exists
  if (
    !isValidObject(alert) ||
    !(id in alert) ||
    !(alert[id] !== null && typeof alert[id] === "object") ||
    !(alertName in (alert[id] as Record<string, unknown>))
  ) {
    void setAlert(alertName, id, actualDate.toISOString());

    return true;
  }

  const usedDate = new Date((alert[id] as Record<string, string>)[alertName]);

  if (actualDate.getDay() !== usedDate.getDay()) {
    void setAlert(alertName, id, actualDate.toISOString());

    return true;
  }

  return actualDate.getTime() - usedDate.getTime() < timeDifferenceThreshold;
};

export { useDailyAlert };
